<template>
  <v-flex xs12>
    
    <v-text-field v-if="type === 'text'" 
      v-model="model"
      :rules="rules" 
      :counter="counter" 
      :label="label"
      :required="required"
      :readonly="isReadonly"
      :disabled="isDisabled"
      @input="onInput"
    >
    </v-text-field>

    <v-textarea v-else-if="type === 'textarea'"  
      v-model="model"
      :rules="rules" 
      :counter="counter" 
      :label="label"
      :required="required"
      :readonly="isReadonly"
      :disabled="isDisabled"
      @input="onInput"
    >
    </v-textarea>

    <autocomplete v-else-if="type === 'autocomplete'"  
      v-model="model"
      :rules="rules"
      :label="label"
      :readonly="isReadonly"
      :disabled="isDisabled"
      @change="onChange"
    >
    </autocomplete>

  </v-flex>
</template>

<script>

  export default {
    props: {
      type: {
        type: String,
        default: 'text'
      },
      counter: Number,
      label: {
        type: String,
        required: true
      },
      value: {
        required: true
      },
      rules: {
        type: Array,
        default () {
          return []
        }
      },
      required: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
      	model: this.value,
        isReadonly: this.readonly,
        isDisabled: this.disabled
      }
    },

    created () {
      	
    },

    methods: {
      
      onInput (val) {
        this.$emit('input', val)
      },

      onChange (val) {
        this.$emit('change', val)
      }
    },

    mounted () {
    	
    },

    watch: {
      
    }

  }
</script>
